import SubmitArrow from './SubmitArrow'

export default SubmitArrow
// eslint-disable-next-line import/export
export * from './SubmitArrow'
